import {
  JobStatus as JsonSchemaJobStatus,
  OrchestrationDiagramNodeConfig,
  OrchestrationGitLink,
  OrchestrationGitVisualNode,
} from '@y42/json-schema';

export enum OrchestrationNodeType {
  Integration = 'Integration',
  SqlModel = 'SqlModel',
  UiModel = 'UiModel',
  Export = 'Export',
}

export enum OrchestrationNodeBindings {
  Location = 'location',
  OnFailure = 'onFailure',
  NodeConfig = 'nodeConfig',

  JobStatus = 'jobStatus',
  JobId = 'jobId',
  RequestId = 'requestId',

  Active = 'active',
  Selected = 'selected',
  Duplicate = 'duplicate',
  DeletedSource = 'deletedSource',
  Filtered = 'filtered',
  AllowIncremental = 'allowIncremental',
}

export interface OrchestrationUINode {
  key: string;
  path: string;
  entityType: string; //DatasourceTypeEnum or ExportTypeEnum
  group?: string;

  [OrchestrationNodeBindings.Location]?: string;
  [OrchestrationNodeBindings.OnFailure]?: 'ignore' | 'stop';
  [OrchestrationNodeBindings.NodeConfig]?: OrchestrationDiagramNodeConfig;

  [OrchestrationNodeBindings.JobId]?: string;
  [OrchestrationNodeBindings.JobStatus]?: JsonSchemaJobStatus;
  [OrchestrationNodeBindings.RequestId]?: string;

  [OrchestrationNodeBindings.Active]?: boolean;
  [OrchestrationNodeBindings.DeletedSource]?: boolean;
  [OrchestrationNodeBindings.Filtered]?: boolean;
  [OrchestrationNodeBindings.Duplicate]?: boolean;
  [OrchestrationNodeBindings.AllowIncremental]?: boolean;
}
export interface OrchestrationDiagramUIModel {
  linkDataArray: OrchestrationGitLink[];
  nodeDataArray: OrchestrationUINode[];
  visualDataArray: OrchestrationGitVisualNode[];
}

export type OrchestrationDiagramMode = 'view' | 'edit';

export interface OrchestrationDiagramConfig {
  model: OrchestrationDiagramUIModel;
  mode: OrchestrationDiagramMode;
}

export enum OrchestrationDiagramModelProperties {
  DiagramMode = 'DiagramMode',
  DerivedNodesDictionary = 'DerivedNodesDictionary',
  ActiveLegend = 'ActiveLegend',
}

export const isOrchestrationDiagramEditable = (mode: OrchestrationDiagramMode) => mode === 'edit';

export interface OrchestrationDerivedNodeDictionary {
  [path: string]: OrchestrationDerivedNode;
}

export interface OrchestrationDerivedNode {
  entityName: string;
  subEntityName: string;
  typeLogo: string;
  nodeType: OrchestrationNodeType;
  subEntityLogo: string;
  allowIncremental: boolean;
}

export const NodesWithIncrementalImport = [OrchestrationNodeType.Integration, OrchestrationNodeType.SqlModel];

export interface OrchestrationUndoManagerStats {
  undoCount: number;
  redoCount: number;
  canUndo: boolean;
  canRedo: boolean;
}
